import * as Yup from "yup";

export const userTransmissionProgressReportSchema = Yup.object().shape({
  users: Yup.array()
    .of(
      Yup.string()
        .matches(/^[a-f\d]{24}$/i, "Each ID must be a valid MongoDB ObjectID")
        .required()
    )
    .min(1, "At least one user must be selected")
    .required("User is required"),
  startDate: Yup.string()
    .required("Start Date is required")
    .test(
      "is-before-end",
      "Start Date cannot be after End Date",
      function (startDate) {
        const { endDate } = this.parent;
        return endDate ? new Date(startDate) <= new Date(endDate) : true;
      }
    ),
  endDate: Yup.string()
    .required("End Date is required")
    .test(
      "is-after-start",
      "End Date cannot be before Start Date",
      function (endDate) {
        const { startDate } = this.parent;
        return startDate ? new Date(endDate) >= new Date(startDate) : true;
      }
    ),
});
